import { render, staticRenderFns } from "./text_v.vue?vue&type=template&id=1ad05bc4&scoped=true&"
import script from "./text_v.vue?vue&type=script&lang=js&"
export * from "./text_v.vue?vue&type=script&lang=js&"
import style0 from "./text_v.vue?vue&type=style&index=0&id=1ad05bc4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad05bc4",
  null
  
)

export default component.exports